import { Alert, MantineColor, Text } from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons-react"
import { ReactNode } from "react"

type Props = {
  title?: ReactNode
  message: ReactNode
  size?: "xs" | "sm" | "md" | "lg"
  color?: MantineColor
  bg?: MantineColor
}

export const InfoBox = ({
  title,
  message,
  color = "gray",
  size = "sm",
  bg,
}: Props) => (
  <Alert
    color={color}
    title={title}
    icon={<IconAlertCircle size="16" />}
    fz={size}
    styles={{ body: { gap: "0.25em" } }}
    bg={bg}
  >
    <Text>{message}</Text>
  </Alert>
)
